import React, { useState, useEffect } from "react";
import { Spin, message } from "antd";
import { LoadingOutlined, HomeOutlined } from "@ant-design/icons";
import { Row, Col } from "antd";
import liracrypt from "../../Liracrypt/liracrypt";
import SessionError from "../../ApiErrorComp/SessionError";
import ApiErrorComp from "../../ApiErrorComp/ApiErrorComp";
import AngelaIconMultiR1C from "../Common/Angela/AngelaIconMultiR1C";
import ZenVerBarChart from "../Common/Graph/ZenVerBarChart";
import ZenGaugeMultiColor from "../Common/Graph/ZenGaugeMultiColor";

// Houdini_ImportData

const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const boxShadow = "5px 5px 14px #181818,-5px -5px 14px #343434";

class ClassChartGrpTest extends React.Component {
  state = {
    mainData: null,
    loading: true,
    loginError: false,
    selectedTab: null,
    lid: "all",
    tabsData: null,
    selectedMnt: "all",
    table: null,
Production: null,
InputManHrs: null,
OutputManHrs: null,
Manpower: null,
Plan: null,
LineStatus: null,
DownTime: null,
Extra: null,
HourlyTrend: null,
Dle: null,
Productivity: null,
PlanAcheivement: null,
    dataLoading: false,
    // Houdini_nullData


  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

 
  componentDidMount() {
    this.props.setPageHeader("Houdini Test Header");
    this._isMounted = true;
    this.fetchChartData();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  fetchChartData = (selectedTab= "all", lid = "all", mnt = "all") => {
    liracrypt
      .get("/chart/charttemplate", {
        lid,
        mnt,
        typ: "MainGraph",
        subTyp: selectedTab,
        chartGroup: "ChartGrpTest",
      })
      .then(({ data }) => {
        const resp = { ...data };
        let respData = {};   
    respData["Production"] = resp["data"]["Production"];
    respData["InputManHrs"] = resp["data"]["InputManHrs"];
    respData["OutputManHrs"] = resp["data"]["OutputManHrs"];
    respData["Manpower"] = resp["data"]["Manpower"];
    respData["Plan"] = resp["data"]["Plan"];
    respData["LineStatus"] = resp["data"]["LineStatus"];
    respData["DownTime"] = resp["data"]["DownTime"];
    respData["Extra"] = resp["data"]["Extra"];
    respData["HourlyTrend"] = resp["data"]["HourlyTrend"];
    respData["Dle"] = resp["data"]["Dle"];
    respData["Productivity"] = resp["data"]["Productivity"];
    respData["PlanAcheivement"] = resp["data"]["PlanAcheivement"];

        // Houdini_RespData
        

        respData["mainData"] = { ...resp };
        this._isMounted &&
          this.setState(
            {
              ...this.state,
              ...respData,
              loading: false,
              dataLoading: false,
            },
            () => {
              // console.log(this.state.dailyTrend);
            }
          );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  render() {
    if (this.state.mainData) {
      return (
        <>
          <SessionError visible={this.state.loginError} />
          <div
            style={{
              background: "#000000",
              paddingTop: 10,
              //   backgroundImage:
              //     "radial-gradient(circle, rgba(98,46,43,1) 0%, rgba(43,36,46,1) 50%, rgba(26,29,36,1) 100%)",
            }}
          >
           
            {this.state.loading === false ? (
              <div>
                <Col span={24}>
                  {this.state.mainData ? (
                    <div
                      style={{
                        margin: "10px",
                        padding: "10px",
                      }}
                    >
                      <div
                        style={{
                          color: "#bdc3c7",
                          fontSize: 28,
                          fontWeight: 400,
                          textAlign: "center",
                          margin: "0px 0px 30px 0px",
                        }}
                      >
                        Energy Dashboard
                      </div>

                      {/* ____________________________________START __________FORMAT________________TEMPLATE___________________*/}

                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "20%" }}></Col>
                        <Col style={{ width: "20%" }}></Col>
                        <Col style={{ width: "20%" }}></Col>
                        <Col style={{ width: "20%" }}></Col>
                      </Row>

                     

                    
{/* _______Row No 1________ */}
                            <Row style={{ background: "#000000" }}>
                              <Col style={{ width: "23%" }}>
                                <div
                              style={{
                                borderRadius: "10px",
                                background: "#191C24",
                                border: "1px solid #3c3e4f",
                                margin: "10px 10px 10px 10px",
                            }}
                            >
	<AngelaIconMultiR1C
		divId={"Production"}
		data={this.state.Production.data}
		config={this.state.Production.config}
		onChange={(data) => this.changeBasicGraph(data)}
	/> 
	 </div>
                              </Col>

                              <Col style={{ width: "23%" }}>
                                <div
                              style={{
                                borderRadius: "10px",
                                background: "#191C24",
                                border: "1px solid #3c3e4f",
                                margin: "10px 10px 10px 10px",
                            }}
                            >
	<AngelaIconMultiR1C
		divId={"InputManHrs"}
		data={this.state.InputManHrs.data}
		config={this.state.InputManHrs.config}
		onChange={(data) => this.changeBasicGraph(data)}
	/> 
	 </div>
                              </Col>

                              <Col style={{ width: "23%" }}>
                                <div
                              style={{
                                borderRadius: "10px",
                                background: "#191C24",
                                border: "1px solid #3c3e4f",
                                margin: "10px 10px 10px 10px",
                            }}
                            >
	<AngelaIconMultiR1C
		divId={"OutputManHrs"}
		data={this.state.OutputManHrs.data}
		config={this.state.OutputManHrs.config}
		onChange={(data) => this.changeBasicGraph(data)}
	/> 
	 </div>
                              </Col>

                              <Col style={{ width: "23%" }}>
                                <div
                              style={{
                                borderRadius: "10px",
                                background: "#191C24",
                                border: "1px solid #3c3e4f",
                                margin: "10px 10px 10px 10px",
                            }}
                            >
	<AngelaIconMultiR1C
		divId={"Manpower"}
		data={this.state.Manpower.data}
		config={this.state.Manpower.config}
		onChange={(data) => this.changeBasicGraph(data)}
	/> 
	 </div>
                              </Col>

                            </Row>
{/* _______Row No 2________ */}
                            <Row style={{ background: "#000000" }}>
                              <Col style={{ width: "23%" }}>
                                <div
                              style={{
                                borderRadius: "10px",
                                background: "#191C24",
                                border: "1px solid #3c3e4f",
                                margin: "10px 10px 10px 10px",
                            }}
                            >
	<AngelaIconMultiR1C
		divId={"Plan"}
		data={this.state.Plan.data}
		config={this.state.Plan.config}
		onChange={(data) => this.changeBasicGraph(data)}
	/> 
	 </div>
                              </Col>

                              <Col style={{ width: "23%" }}>
                                <div
                              style={{
                                borderRadius: "10px",
                                background: "#191C24",
                                border: "1px solid #3c3e4f",
                                margin: "10px 10px 10px 10px",
                            }}
                            >
	<AngelaIconMultiR1C
		divId={"LineStatus"}
		data={this.state.LineStatus.data}
		config={this.state.LineStatus.config}
		onChange={(data) => this.changeBasicGraph(data)}
	/> 
	 </div>
                              </Col>

                              <Col style={{ width: "23%" }}>
                                <div
                              style={{
                                borderRadius: "10px",
                                background: "#191C24",
                                border: "1px solid #3c3e4f",
                                margin: "10px 10px 10px 10px",
                            }}
                            >
	<AngelaIconMultiR1C
		divId={"DownTime"}
		data={this.state.DownTime.data}
		config={this.state.DownTime.config}
		onChange={(data) => this.changeBasicGraph(data)}
	/> 
	 </div>
                              </Col>

                              <Col style={{ width: "23%" }}>
                                <div
                              style={{
                                borderRadius: "10px",
                                background: "#191C24",
                                border: "1px solid #3c3e4f",
                                margin: "10px 10px 10px 10px",
                            }}
                            >
	<AngelaIconMultiR1C
		divId={"Extra"}
		data={this.state.Extra.data}
		config={this.state.Extra.config}
		onChange={(data) => this.changeBasicGraph(data)}
	/> 
	 </div>
                              </Col>

                            </Row>
{/* _______Row No 3________ */}
                            <Row style={{ background: "#000000" }}>
                              <Col style={{ width: "97%" }}>
                                <div
                              style={{
                                borderRadius: "10px",
                                background: "#191C24",
                                border: "1px solid #3c3e4f",
                                margin: "10px 10px 10px 10px",
                            }}
                            >
	<ZenVerBarChart
		divId={"HourlyTrend"}
		data={this.state.HourlyTrend.data}
		config={this.state.HourlyTrend.config}
		onChange={(data) => this.changeBasicGraph(data)}
	/> 
	 </div>
                              </Col>

                            </Row>
{/* _______Row No 4________ */}
                            <Row style={{ background: "#000000" }}>
                              <Col style={{ width: "97%" }}>
                                <div
                              style={{
                                borderRadius: "10px",
                                background: "#191C24",
                                border: "1px solid #3c3e4f",
                                margin: "10px 10px 10px 10px",
                            }}
                            >
	<ZenGaugeMultiColor
		divId={"Dle"}
		data={this.state.Dle.data}
		config={this.state.Dle.config}
		onChange={(data) => this.changeBasicGraph(data)}
	/> 
	 </div>
                              </Col>

                            </Row>
{/* _______Row No 5________ */}
                            <Row style={{ background: "#000000" }}>
                              <Col style={{ width: "97%" }}>
                                <div
                              style={{
                                borderRadius: "10px",
                                background: "#191C24",
                                border: "1px solid #3c3e4f",
                                margin: "10px 10px 10px 10px",
                            }}
                            >
	<ZenGaugeMultiColor
		divId={"Productivity"}
		data={this.state.Productivity.data}
		config={this.state.Productivity.config}
		onChange={(data) => this.changeBasicGraph(data)}
	/> 
	 </div>
                              </Col>

                            </Row>
{/* _______Row No 6________ */}
                            <Row style={{ background: "#000000" }}>
                              <Col style={{ width: "97%" }}>
                                <div
                              style={{
                                borderRadius: "10px",
                                background: "#191C24",
                                border: "1px solid #3c3e4f",
                                margin: "10px 10px 10px 10px",
                            }}
                            >
	<ZenGaugeMultiColor
		divId={"PlanAcheivement"}
		data={this.state.PlanAcheivement.data}
		config={this.state.PlanAcheivement.config}
		onChange={(data) => this.changeBasicGraph(data)}
	/> 
	 </div>
                              </Col>

                            </Row>
                     
                      {/* Houdini_DivData */}





                    </div>
                  ) : null}
                </Col>

              </div>
            ) : (
              <div className="Loading" style={{ minHeight: "100vh" }}>
                <Spin indicator={antIcon} />
              </div>
            )}
          </div>
        </>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}

export default ClassChartGrpTest;
